import { lazyComponent } from '@/utils/lazyComponent'

// 신규 Okta 로그인 페이지(랜딩) — /auth/okta-login
export default lazyComponent(() => import('./OktaLogin'))
